<div>
  <div class="row-no-margin section-header-container">
    <div class="col-md-12 clear-padding">
      <span class="section-header">Quotes</span>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill">
            <mat-label>Sort by:</mat-label>
            <mat-select id="quoteSort" (selectionChange)="QuoteSort_Change($event)" [(value)]="QuoteSortValue">
              <mat-option value="orderdate">
                Most Recent
              </mat-option>
              <mat-option value="statusopen">
                Open Quotes
              </mat-option>
              <mat-option value="shipto">
                Ship To Name
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 clear-padding">
          <mat-form-field *ngIf="CurUser.IsTolomaticUser" appearance="fill">
            <mat-label>Distributor:</mat-label>
            <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist.CompanyId">
              <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
                {{dist.Company}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 clear-padding" style="text-align:right;">
          <button [hidden]="!CurUser.IsTolomaticUser" class="blue clickable" (click)="CreateNewQuote()">Create Quote</button>
        </div>

      </div>

      <!--<div class="col-md-2 clear-padding" style="text-align:right;">
        <a [routerLink]="['/orderstatus']">View all status</a>
      </div>-->

    </div>
  </div>
  <div>
    <table class="mainGrid" style="width:100%;">
      <tr>
        <th></th>
        <th>Quote Number</th>
        <th style="text-align:center;">Customer Name</th>
        <th style="text-align:center;">Ship To</th>
        <th style="text-align:center;">Project Name</th>
        <th style="text-align:center;">Effective Date</th>
        <th style="text-align:center;">Expiration Date</th>
        <th style="text-align:center;"></th>
      </tr>
      <ng-container *ngFor="let order of QuoteList">
        <tr>
          <td>
            <button mat-icon-button aria-label="expand row" (click)="(order.Expanded = !order.Expanded); LoadDetails(order); $event.stopPropagation()">
              <mat-icon *ngIf="!order.Expanded" class="blue-color">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="order.Expanded" class="blue-color">keyboard_arrow_up</mat-icon>
            </button>
          </td>
          <td>
            @if(order.IsV2 && CurUser.IsTolomaticUser){
            <span class="blue clickable" (click)="OpenQuote(order)">{{order.QuoteNumber}}</span>
            }
            @else{
            {{order.QuoteNumber}}
            }

          </td>
          <td style="text-align:center;">{{order.CustomerName}}</td>
          <td style="text-align:center;" ><span [matTooltip]="order.ShipToName">{{order.ShortShipTo}}</span></td>
          <td style="text-align:center;"><span [matTooltip]="order.Description">{{order.ProjectName}}</span></td>
          <td style="text-align:center;">{{order.EffectiveDate | date:'shortDate'}}</td>
          <td style="text-align:center;">{{order.ExpirationDate | date:'shortDate'}}</td>
          <td style="text-align:center;"><span class="clickable blue-color" (click)="GetQuoteReport(order)">Quote Report</span></td>
          <!--<td style="text-align:center;"><app-toggle [initial]="order.Following" [idForControl]="order.OrderNumber" [trueText]="" [falseText]="" (changed)="FollowOrder($event,order.OrderNumber)"></app-toggle></td>-->
        </tr>
        <ng-container *ngIf="order.Expanded">
          <tr>
            <td colspan="8">
              <table class="sub-table" style="width:100%;">
                <tr>
                  <th>Line</th>
                  <th style="text-align:center;">Item</th>
                  <th style="text-align:center;">Description</th>
                  <th style="text-align:center;">QTY</th>
                  <th style="text-align:center;"></th>
                  <th style="text-align:center;">List Price</th>
                  <th style="text-align:center;">Ext Price</th>
                </tr>
                <ng-container *ngFor="let detail of order.QuoteDetails">
                  <tr>
                    <td style="text-align:center;">
                      {{detail.OrderLine}}
                    </td>
                    <td>
                      {{detail.Item}}
                    </td>
                    <td >
                      <span [matTooltip]="detail.Description">{{detail.ShortDesc}}</span>
                    </td>
                    <td style="text-align:center;">
                      {{detail.QtyOrdered}}
                    </td>
                    <td>
                      <table style="width:100%;">
                        <tr>
                          <th style="text-align:center; font-weight:bold; border-bottom:1px solid black;">Quantity</th>
                          <th style="text-align: center; font-weight: bold; border-bottom: 1px solid black; ">Discount</th>
                          <th style="text-align: right; font-weight: bold; border-bottom: 1px solid black; ">Unit Price</th>
                        </tr>
                        <ng-container *ngIf="detail.BreakQty1 >= 1">
                          <tr>
                            <td style="text-align:center;">{{detail.GetBreakQtyString(0)}}</td>
                            <td style="text-align:center;"></td>
                            <td style="text-align:right;">{{ detail.UnitPrice1 | currency}}</td>
                          </tr>                          
                        </ng-container>
                        <ng-container *ngIf="detail.BreakQty2 >= 1">
                          <tr>
                            <td style="text-align:center;">{{detail.GetBreakQtyString(1)}}</td>
                            <td style="text-align:center;"></td>
                            <td style="text-align:right;">{{ detail.UnitPrice2 | currency }}</td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail.BreakQty3 >= 1">
                          <tr>
                            <td style="text-align:center;">{{detail.GetBreakQtyString(2)}}</td>
                            <td style="text-align:center;"></td>
                            <td style="text-align:right;">{{detail.UnitPrice3  | currency}}</td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail.BreakQty4 >= 1">
                          <tr>
                            <td style="text-align:center;">{{detail.GetBreakQtyString(3)}}</td>
                            <td style="text-align:center;"></td>
                            <td style="text-align:right;">{{detail.UnitPrice4 | currency}}</td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail.BreakQty5 >= 1">
                          <tr>
                            <td style="text-align:center;">{{detail.GetBreakQtyString(4)}}</td>
                            <td style="text-align:center;"></td>
                            <td style="text-align:right;">{{detail.UnitPrice5 | currency}}</td>
                          </tr>
                        </ng-container>
                      </table>
                      
                    </td>
                    <td style="text-align:center;">
                      {{detail.ListPrice | currency}}
                    </td>
                    <!--<td style="text-align:center;">
                      {{detail.Price}}
                    </td>-->
                  <td style="text-align:center;">
                    {{detail.GetExtPrice() | currency}}
                  </td>
                  </tr>
                </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
      </ng-container>

    </table>
    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
